import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { HiArrowLongLeft } from 'react-icons/hi2';
import { useNavigate } from 'react-router';

import LinkButton from '../LinkButton';

interface Props {
  className?: string;
  href?: string;
  backText?: string;
}

function BackButton({ className, href, backText }: Props): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <LinkButton
      className={clsx('flex items-center space-x-2', className)}
      onClick={() => (href ? navigate(href) : navigate(-1))}
    >
      <HiArrowLongLeft className="h-6 w-6" />
      <div>{backText || t('buttons.back')}</div>
    </LinkButton>
  );
}

export default BackButton;
